/**
 * Scroll Reveal — lightweight IntersectionObserver utility.
 *
 * Elements with `data-scroll-reveal` fade-up when they enter the viewport.
 * Elements with `data-scroll-reveal="stagger"` reveal children in sequence.
 *
 * Respects `prefers-reduced-motion: reduce` — does nothing if set.
 * Re-observes on `shopify:section:load` for theme editor compatibility.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    document
      .querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')
      .forEach((el) => observer.observe(el));
  }

  observe();
  document.addEventListener('shopify:section:load', observe);
})();
